import { render, staticRenderFns } from "./JgpForm.vue?vue&type=template&id=659a6e0a&"
import script from "./JgpForm.vue?vue&type=script&lang=js&"
export * from "./JgpForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports